const careerRoutes = [
  {
    path: "/career",
    name: "studentCareer",
    meta: {
      title: "진로설계",
      isDynamic: true,
    },
    children: [
      {
        path: "design",
        name: "studentCareerDesign",
        meta: {
          title: "진로설계",
          menuCd: "STUDENT_CAREER_DESIGN",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/careear/StudentCarrerPlanList.vue"),
      },
      {
        path: "design/create",
        name: "studentCareerDesignDetail",
        meta: {
          title: "진로설계 생성",
          menuCd: "STUDENT_CAREER_DESIGN",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/careear/StudentCarrerPlan.vue"),
      },
    ],
  },
];

export default careerRoutes;
